import React from "react";
import type { IconProps } from "./type";
import { COLORS } from "@/app/common/consts/colors";

const MapIcon = ({ color = "offWhite" }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M14 13.4167C13.2265 13.4167 12.4846 13.1094 11.9376 12.5624C11.3906 12.0154 11.0833 11.2736 11.0833 10.5C11.0833 9.72646 11.3906 8.9846 11.9376 8.43762C12.4846 7.89063 13.2265 7.58334 14 7.58334C14.7736 7.58334 15.5154 7.89063 16.0624 8.43762C16.6094 8.9846 16.9167 9.72646 16.9167 10.5C16.9167 10.883 16.8412 11.2623 16.6947 11.6162C16.5481 11.97 16.3332 12.2916 16.0624 12.5624C15.7916 12.8332 15.47 13.0481 15.1162 13.1947C14.7623 13.3412 14.383 13.4167 14 13.4167ZM14 2.33334C11.8341 2.33334 9.75685 3.19376 8.2253 4.7253C6.69376 6.25685 5.83334 8.33408 5.83334 10.5C5.83334 16.625 14 25.6667 14 25.6667C14 25.6667 22.1667 16.625 22.1667 10.5C22.1667 8.33408 21.3063 6.25685 19.7747 4.7253C18.2432 3.19376 16.1659 2.33334 14 2.33334Z"
        fill={COLORS[color]}
      />
    </svg>
  );
};

export default MapIcon;
